import React from 'react';
import ReactDOM from 'react-dom/client';
import ContainedPhotoModule from './ContainedPhotoModule';
import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ContainedPhotoModule/>
);
